import { Action, ActionType, createAction } from 'typesafe-actions';

export const interfaceActions = {
  increaseNumberOfActiveActions: createAction('[INTERFACE] increase the number of active actions')(),
  reduceNumberOfActiveActions: createAction('[INTERFACE] reduce the number of active actions')(),
  toggleLoadingSection: createAction('[INTERFACE] toggle loading section')<boolean>(),
};

export type interfaceActions = Action | ActionType<typeof interfaceActions>;
